import {
  GET_BOOKS_ORDER,
  GET_BOOK_ORDER,
  SET_ALL_BOOKSORDER,
  UPDATE_BOOK_ORDER,
} from "../../reducerTypes";

const initialState = {
  getData: {},
  getList: [],
  selectData: [],
};

const BookOrderReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_ALL_BOOKSORDER:
      return {
        ...state,
        getList: action.payload,
      };
    case GET_BOOKS_ORDER:
      return {
        ...state,
        getList: action.payload,
      };
    case GET_BOOK_ORDER:
      return {
        ...state,
        getData: action.payload,
      };
    case UPDATE_BOOK_ORDER:
      return {
        ...state,
        getData: action.payload,
      };
    default:
      return state;
  }
};

export default BookOrderReducer;
